<template>
	<b-form @submit.stop.prevent='onSubmit' class='login-form'>

		<b-form-group label='Имя пользователя' label-class='login-input-label'>
			<b-form-input v-model='formData.username' required placeholder='введите имя пользователя'>
			</b-form-input>
		</b-form-group>

		<b-form-group label='Пароль' label-class='login-input-label'>
			<b-input-group>

				<template #append>
					<b-input-group-text @click='togglePasswordVisible' class='toggle-password-btn'>
						<b-icon v-if='passwordIsVisible' icon='eye-slash'></b-icon>
						<b-icon v-else icon='eye'></b-icon>
					</b-input-group-text>
				</template>

				<b-form-input v-model='formData.password' required placeholder='введите пароль' :type='passwordInputType'>
				</b-form-input>
			</b-input-group>
		</b-form-group>

		<b-form-group>
			<div class='lpo-custom-checkbox'>
				<label>
					<span>Запомнить меня</span>
					<input v-model='formData.remember' type='checkbox'>
					<!-- <custom-p-checkbox v-model='formData.remember' label='Запомнить меня' labelLeft/> -->
				</label>
			</div>
		</b-form-group>

		<b-button type='submit' block variant='success'>Войти</b-button>

	</b-form>
</template>

<script>

export default {
	name: 'LoginForm',

	data: () => ({
		passwordIsVisible: false,

		formData: {
			username: null,
			password: null,
			remember: true
		}
	}),

	computed: {
		passwordInputType() {
			return this.passwordIsVisible ? 'text' : 'password'
		},
	},

	methods: {
		togglePasswordVisible() {
			this.passwordIsVisible = !this.passwordIsVisible;
		},

		onSubmit() {
			this.$emit('submit', this.formData);
		}
	}
};

</script>

<style scoped>
	.lpo-custom-checkbox {
		
	}

	.lpo-custom-checkbox label {
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.lpo-custom-checkbox span {
		color: #bbb;
		margin-right: 1rem;
	}

	.login-form >>> .login-input-label {
		color: #bbb;
		font-size: 1rem;
	}

	.toggle-password-btn {
		cursor: pointer;
	}
</style>